import Swiper from 'swiper';
import { EffectFade, Pagination, Autoplay } from 'swiper/modules';

function init(){
    const swiper = new Swiper('.block-banner-slider', {
        modules: [EffectFade, Pagination, Autoplay],
        // centeredSlides: true,
        slidesPerView: 1,
        loop: true,
        autoplay: {
            delay: 8000,
            disableOnInteraction: false
        },
        spaceBetween: 0,
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
    });
}
export default function HeroSlider() {
    init();
}
